import React from 'react';
import { TableLayout } from './table-layout';
export function Table({ ...rest }) {
    return React.createElement(TableLayout, { ...rest });
}
